import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

const audio = tokenDefinition({
  name: TokenName.AUDIO,
  type: TokenType.KEYWORD,
  tokenMatcher: /^AUDIO/,
  contentMatcher: /^AUDIO/
});

const playIcon = "&#9205;"//"&#128266;"

class Audio {

  consume(tokenIterator, nodeIterator) {

    if(this.isAudio(tokenIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }

  }

  onEndOfMarkup(openNode) {
    openNode.cancel()
  }

  toHtml(node, toHtml, idProvider) {
    // build the all audio at once, toHtml callback is not used
    let audioId =  node.children
    .filter( (child) => child.name === NodeName.MEDIA_ID)[0].value

    return `
    <span class="clickable-icon icon-play" onclick="document.getElementById('audio-${audioId}').play()"></span>
    <audio id="audio-${audioId}" src="/public/api/media/${audioId}" type="audio/mpeg"></audio>`
  }

  isAudio(tokenIterator) {
    // Validate that the all node has been written
    // OPEN_SPECIAL AUDIO PIPE audioId CLOSE_SPECIAL
    return tokenIterator.hasNext(5)
        && tokenIterator.tokens[tokenIterator.index].name === TokenName.OPEN_SPECIAL
        && tokenIterator.tokens[tokenIterator.index +1].name === TokenName.AUDIO
        && tokenIterator.tokens[tokenIterator.index +2].name === TokenName.PIPE
        && tokenIterator.tokens[tokenIterator.index +3].name === TokenName.CHARACTER_LITERAL
        && tokenIterator.tokens[tokenIterator.index +4].name === TokenName.CLOSE_SPECIAL
  }

  openNewNode(tokenIterator, nodeIterator) {
    // map the all audio node at once adding values as children
    // OPEN_SPECIAL AUDIO PIPE audioId CLOSE_SPECIAL
    let audioType = tokenIterator.tokens[tokenIterator.index + 1].content
    let audioId = tokenIterator.tokens[tokenIterator.index + 3].value

    let audioNode = new Node(
        NodeName.AUDIO,
        audioType,
        new Audio(),
        nodeIterator.currentParentNode
    )

    let mediaId = new Node(
        NodeName.MEDIA_ID,
        audioId,
        null,
        audioNode
    ).close();
    audioNode.addChildren([mediaId])

    nodeIterator.addClosedNode(audioNode)
    tokenIterator.eatTokens(5)
  }

}

export {audio, Audio}